


































import _ from 'lodash';
import MatrixConfig from '@/domain/matrix-config/entity/matrix-config.entity';
import { Vue, Component, Prop } from 'vue-property-decorator';
import Quadrant from '@/domain/matrix-config/entity/quadrant.entity';
import QuadrantComponent from './quadrant.component.vue';

@Component({
  components: {
    QuadrantComponent,
  },
})
export default class QuadrantsPanel extends Vue {
  @Prop({ type: MatrixConfig, required: true })
  matrixConfig!: MatrixConfig;

  @Prop({ type: String, default: '' })
  selectedQuadrantId!: string;

  get matrixGroupedByYAxisPosition() {
    return _.groupBy(
      this.matrixConfig.quadrants,
      (quadrant: Quadrant) => quadrant.yAxisLevel.position,
    );
  }

  selectQuadrant(quadrantId: string) {
    this.$emit('selectQuadrant', quadrantId);
  }
}
